import { render, staticRenderFns } from "./ReservationPageEdit.vue?vue&type=template&id=1c08e2ae&scoped=true"
import script from "./ReservationPageEdit.vue?vue&type=script&lang=js"
export * from "./ReservationPageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08e2ae",
  null
  
)

export default component.exports